import { IS_DENTAL_AND_VISION } from 'core/constants/environment'
import { findProductTypeNames } from '../product/complianceProducts'

function getComplianceParams(state: Pivot.State): ComplianceRequestParams | undefined {
  if (!state) return undefined

  const { plans, planId, dentalPlanId, visionPlanId, latitudeId, hcStorage } = state

  let isMultiCarrier = false

  const compliancePlans = []

  if (!IS_DENTAL_AND_VISION) {
    isMultiCarrier = state.plans[planId].multiCarrierPlan

    if (isMultiCarrier) {
      // Get compliance for each plan type within the multi-carrier order
      const planOrders = Object.entries(state.multiCarrierOrder).map(order => order[1])
      const relevantOrder = planOrders.find(order => order.includes(planId))
      relevantOrder.forEach(id => compliancePlans.push(plans[id]))
    } else {
      compliancePlans.push(plans[planId])
    }
  }

  const compliancePlansOrdered = compliancePlans.concat([
    plans[dentalPlanId],
    plans[visionPlanId],
    plans[latitudeId]
  ])

  const products = findProductTypeNames(compliancePlansOrdered.filter(Boolean))

  const params = {
    products,
    stateAcronym: hcStorage.location.state_acronym,
    agentId: hcStorage.agent_id,
    multiCarrier: isMultiCarrier
  }

  if (planId != null) params.planIds = [planId]

  return params
}

export default getComplianceParams
